import {
  DropdownMenu,
  GhostIconButton,
  MenuItem,
  MenuSection,
  Text,
} from "@certn/cascadia-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { DeactivateTagModal } from "./DeactivateTagModal";
import { EditTagModal } from "./EditTagModal";
import { ReactivateTagModal } from "./ReactivateTagModal";

interface Props {
  tagName: string;
  isActive: boolean;
  id: string;
}
export function ActionsDropdown(props: Props) {
  const { t } = useTranslation();
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeactivateModal, setShowDeactivateModal] =
    useState<boolean>(false);
  const [showReactivateModal, setShowReactivateModal] =
    useState<boolean>(false);

  const { tagName, isActive, id } = props;
  return (
    <>
      <DropdownMenu
        triggerButton={
          <GhostIconButton
            testID="tags-listing-item-expand-button"
            size="small"
            icon="more_horiz"
            aria-label={t("Expand menu")}
          />
        }
        onItemAction={(menuItem) => {
          switch (menuItem) {
            case "edit-tag":
              setShowEditModal(true);
              break;
            case "reactivate-tag":
              setShowReactivateModal(true);
              break;
            case "deactivate-tag":
              setShowDeactivateModal(true);
              break;
          }
        }}
        placement="bottom right"
        aria-label="dropdown menu"
      >
        <MenuSection>
          <MenuItem id="edit-tag" aria-label="edit" testID="edit-button">
            <Text style="input/text-field" testID="edit-tag-button">
              {t("Edit")}
            </Text>
          </MenuItem>
          {!isActive ? (
            <MenuItem
              id="reactivate-tag"
              aria-label="reactivate"
              testID="reactivate-button"
            >
              <Text style="input/text-field" testID="reactivate-tag-button">
                {t("Reactivate")}
              </Text>
            </MenuItem>
          ) : (
            <MenuItem
              id="deactivate-tag"
              aria-label="deactivate"
              testID="deactivate-button"
            >
              <Text
                style="input/text-field"
                testID="deactivate-tag-button"
                color="text-danger"
              >
                {t("Deactivate")}
              </Text>
            </MenuItem>
          )}
        </MenuSection>
      </DropdownMenu>
      <EditTagModal
        isOpen={showEditModal}
        onClose={() => setShowEditModal(false)}
        id={id}
        tagName={tagName}
      />
      <DeactivateTagModal
        isOpen={showDeactivateModal}
        onClose={() => setShowDeactivateModal(false)}
        tagName={tagName}
        id={id}
      />
      <ReactivateTagModal
        isOpen={showReactivateModal}
        onClose={() => {
          setShowReactivateModal(false);
        }}
        tagName={tagName}
        id={id}
      />
    </>
  );
}
